const getAssessmentItemMappingsSubtitle = (linkedAssessments) => {
  if (!linkedAssessments || !linkedAssessments.length) {
    return null;
  }

  if (linkedAssessments.length === 1) {
    return 'Composed of 1 linked assessment';
  }

  return `Composed of ${linkedAssessments.length} linked assessments`;
};

export default getAssessmentItemMappingsSubtitle;
